<template>
  <button
    class="relative flex justify-center items-center text-proton-grey opacity-60 focus:outline-none focus:opacity-80 hover:opacity-80 group"
    v-clipboard:copy="content"
    v-clipboard:success="onCopySuccess"
    v-clipboard:error="onCopyError"
    @click.stop
    :aria-label="copyText"
  >
    <div class="tooltip group-hover:block">
      <span class="text-white">{{ copyText }}</span>
    </div>
    <copy class="w-16 fill-current" />
  </button>
</template>

<script>
import Copy from '@/assets/images/copy.svg'

export default {
  props: {
    content: {
      type: String,
      required: true
    },
    copyMessage: {
      type: String,
      default: 'Copy'
    },
    successMessage: {
      type: String,
      default: 'Copied!'
    },
    errorMessage: {
      type: String,
      default: "Couldn't copy"
    }
  },
  components: { Copy },
  data() {
    return {
      copyText: this.copyMessage
    }
  },
  methods: {
    onCopySuccess() {
      this.copyText = this.successMessage
      this.resetCopyText()
    },
    onCopyError() {
      this.copyText = this.errorMessage
      this.resetCopyText()
    },
    resetCopyText() {
      setTimeout(() => {
        this.copyText = this.copyMessage
      }, 1000)
    }
  }
}
</script>
